export default __webpack_public_path__ + "static/media/Gradient.e4c6e790.png";